// extracted by mini-css-extract-plugin
export var modal = "_v3-0";
export var table = "_v3-1";